export default __webpack_public_path__ + "static/media/1308.53ef3135.png";